import { useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Footer } from "../../../components/Landing/Footer";
import { Table, Button, Modal, Collapse } from "antd";
import { ReactComponent as EyeIcon } from "../../../assets/eye-detail.svg";
import collageMentorias from "../../../assets/landing/collage-mentorias.png";
import mentoriaMarca from "../../../assets/landing/mentoriaMarca.png";
import mentoriaDerechos from "../../../assets/landing/mentoriaDerechos.png";
import mentoriaLEP from "../../../assets/landing/mentoriaLEP.png";
import mentoriaOne from "../../../assets/landing/mentoriaOne.png";
import lepRecursos from "../../../assets/recursos lep.png";
import { CarouselLEP } from "../components/Carousel/CarouselLEP";
import { backgroundClip } from "html2canvas/dist/types/css/property-descriptors/background-clip";
import { FaStar, FaEnvelope, FaQuestionCircle } from "react-icons/fa";

const { Panel } = Collapse;

export const Mentorias = () => {

  const [visualizasdocument, setVisualizarDocument] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  const visualizarModal = (url) => {
    setUrl(url)
    setVisualizarDocument(true);
  }

  const onCancel = () => {
    setVisualizarDocument(false);
    setUrl('')
  }

  const handleEmailClick = () => {
    window.location.href = 'mailto:mentoriascultura@medellin.gov.co';
  };

  return (
    <>
      <Header />
      <HeaderScc />
      <div className="container-fluid2">
        <div className="row">
          <br />
        </div>
        <div className="row" style={{backgroundColor: '#faad1414'}}>
          <div className="col-12 col-md-6 col-sm-12">
            <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:48, position: 'relative', top: '24px'}}>
              <strong>
                Mentorías
              </strong>
            </div>
            <br />
            <br />
            <div className="font-size-24px font-family-Montserrat text-justify font-color-black">
              Es el componente pedagógico del proceso de convocatorias.
              <br />
              Esta es tu oportunidad para adquirir herramientas y conocimientos que potencien tus capacidades para la formulación y presentación de proyectos en las Convocatorias de Fomento y Estímulos al Arte y la Cultura de la ciudad y otros escenarios de participación
            </div>
          </div>
          <div className="col-12 col-md-6 col-sm-12 justify-content-center">
            <img src={collageMentorias} style={{maxWidth: '80%'}} alt="Mentorias estimulos cultura medellin"></img>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-sm-12 text-center cajasMentorias" style={{backgroundColor: '#7fffd440'}}>
            <div className="font-size-24px font-family-Montserrat text-center font-color-black">
              <strong>¿Qué si es una mentoría?</strong>
              <br />
                Un proceso de orientación y fortalecimiento.
            </div>
          </div>
          <div className="col-12 col-md-6 col-sm-12 justify-content-center cajasMentorias" style={{backgroundColor: '#ff7f5030'}}>
            <div className="font-size-24px font-family-Montserrat text-center font-color-black">
              <strong>¿Qué NO es una mentoría?</strong>
              <br />
                No garantiza la selección del proyecto, pero sí aporta conocimientos valiosos.
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="row justify-content-center">
          <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:48}}>
            <strong>
              ¿Cómo te acompañamos?
            </strong>
          </div>
          <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:26}}>
            Conoce todas las opciones que tenemos para acompañarte en tu proceso de mentoría
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row justify-content-center text-center" style={{backgroundColor: 'whitesmoke', padding:10, borderRadius:10}}>
          <div className="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
            <FaEnvelope style={{ fontSize: '44px' }} />
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <p>
                ¿Tienes algún problema?
                <br />
                ¿Hay algo que no comprendes?
                <br />
                ¿Tienes dudas sobre los formularios y la documentación?
              </p>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <Button
              type="link"
              className="button-azul-radius-detalle"
              style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
              onClick={handleEmailClick}
            >
              <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Contactar</span>
            </Button>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row justify-content-center text-center" style={{backgroundColor: 'whitesmoke', padding:10, borderRadius:10}}>
          <div className="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
            <FaQuestionCircle style={{ fontSize: '44px', display: 'inline-block', whiteSpace: 'nowrap' }} />
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <p>Si es tu primera vez formulando un proyecto o no conoces de qué se trata el objetivo, la justificación, la metodología y demás componentes básicos de la formulación</p>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <Button
              type="link"
              className="button-azul-radius-detalle"
              style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
              onClick={handleEmailClick}
            >
              <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Contactar</span>
            </Button>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="justify-content-center" style={{backgroundColor: '#f3f4f6', padding: 20}}>
          <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:30}}>
            <strong>Participa de nuestros programas de acompañamiento</strong>
          </div>
        </div>
        <div className="row justify-content-center" style={{backgroundColor:'#f3f4f6'}}>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaMarca}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de infraestructura</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaDerechos}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de audiovisuales</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaLEP}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de gestión cultural</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaOne}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de artes plásticas y visuales</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:30}}>
          <strong>Consejos para participar</strong>
        </div>
        <Collapse accordion>
          <Panel header="1. Analiza" key="1">
            <p>Lee atentamente la convocatoria, conoce sus detalles, identifica los requisitos y documentos solicitados, revisa los formularios. Si tienes dudas, escríbenos a convocatorias.cultura@medellin.gov.co</p>
          </Panel>
          <Panel header="2. Analiza" key="2">
            <p>Explora la plataforma y familiarízate con su funcionamiento (sobre todo si es tu primera vez). Necesitas soporte con la plataforma, escríbenos a convocatorias.cultura@medellin.gov.co</p>
          </Panel>
          <Panel header="3. Estructura tu proyecto" key="3">
            <p>Diligencia los formularios y recolecta la documentación necesaria. Si no sabes cómo hacer un objetivo, la justificación u otros elementos de la formulación, escríbenos a mentoriascultura@medellin.gov.co</p>
          </Panel>
          <Panel header="4. Chequea" key="4">
            <p>Verifica que tienes los documentos solicitados, evalúa tu proyecto y realiza ajustes. Conversa con colegas y amigos, piensa quiénes pueden ayudarte a revisar tu proyecto.</p>
          </Panel>
          <Panel header="5. Inscribe" key="5">
            <p>Tu propuesta con tiempo en la plataforma ¡No lo dejes para el último día!</p>
          </Panel>
        </Collapse>
      </div>
      <Modal
        className="ant-modal-close-x2"
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.71)",
        }}
        visible={visualizasdocument}
        onCancel={onCancel}
        width={1200}
        footer={[
          <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
            Cerrar
          </Button>,
        ]}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          <iframe src={url} style={{ width: '100%', height: '500px' }}></iframe>
        </div>
      </Modal>
      <Footer />
    </>
  );
};
